/**
 * Dynamic Configuration
 * Automatically detects and sets the API URL based on the current environment
 */

// Get the current window location
const getApiUrl = () => {
  // Check if there's an environment variable set (for production builds)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Auto-detect based on current domain
  const { protocol, hostname } = window.location;

  // If running on localhost, use localhost backend
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api';
  }

  // For production, use the same domain with /api
  return `${protocol}//${hostname}/api`;
};

const config = {
  apiUrl: getApiUrl(),
};

export default config;
